// extracted by mini-css-extract-plugin
export default {"text":"app-lists-ListMoveModal-ListMoveModal-module__eBXzEcAWCAV42LxtDZJj","field":"app-lists-ListMoveModal-ListMoveModal-module__Pn5WtMg62vYNzBwBh85f"};